export default __webpack_public_path__ + "static/SRUS SSC300 - Especification Del Producto y Datos Técnicos-b542ecdb81a26282f2382b2ea6ddd717.pdf";